import { Card, CardContent } from "@/components/card";
import { LogoAnimation } from "@/components/Logo/logoAnimation";

export const LoadingScreen = () => {
  return (
    <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-background px-6">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,hsl(var(--primary)/0.1),transparent_42%)]" />

      <Card className="relative w-full max-w-xs rounded-2xl border-border/70 bg-card/90 shadow-xl shadow-primary/5 backdrop-blur-sm">
        <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
          <div className="flex size-16 items-center justify-center rounded-xl border border-primary/15 bg-primary/5">
            <LogoAnimation size={34} variant="spin" />
          </div>
          <span className="text-xs font-medium text-muted-foreground">
            Laster inn …
          </span>
        </CardContent>
      </Card>
    </div>
  );
};
